import React from 'react';
import { createRoot } from 'react-dom/client';
import 'index.scss';
import App from 'containers/App';
import reportWebVitals from 'reportWebVitals';

const root = createRoot(document.getElementById('root') as HTMLDivElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
